import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';

interface Props {
  value: boolean | unknown[];
  checkboxValue?: number | string | null;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbCheckbox',
  props: {
    value: { type: [Boolean, Array], default: false },
    checkboxValue: { default: null },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean | unknown[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean | unknown[], checkboxValue: number | string | null, disabled: boolean };





const valueLocal = computed({
  get() {
    if (Array.isArray(props.value)) {
      return props.value.includes(props.checkboxValue);
    }
    return props.value;
  },
  set(newValue) {
    if (Array.isArray(props.value)) {
      const newArray = [...props.value];
      if (newValue) {
        if (!newArray.includes(props.checkboxValue)) {
          newArray.push(props.checkboxValue);
        }
      } else {
        const index = newArray.indexOf(props.checkboxValue);
        if (index > -1) {
          newArray.splice(index, 1);
        }
      }
      emit('input', newArray);
    } else {
      emit('input', newValue);
    }
  },
});

return { __sfc: true,props, emit, valueLocal }
}

})